export const contentGenerator = {
  pageTitle: 'Generador de Contenido',
  pageDescription: 'Configura los datos, genera un brief y crea tu artículo optimizado.',
  generateButton: 'Generar Artículo',
  generating: 'Generando artículo...',
  progress: {
    label: 'Progreso',
    basics: 'Datos',
    brandVoice: 'Voz de Marca',
    brief: 'Brief',
  },
  sections: {
    content: 'Contenido',
    seo: 'SEO y Entidad',
    brandVoice: 'Voz de Marca',
    images: 'Imágenes',
    sources: 'Fuentes y Referencias',
    advanced: 'Configuración Avanzada',
    subtitles: {
      images: 'Elegí entre fotos de stock o imágenes generadas con IA',
      sources: 'Agrega fuentes para mejorar la precisión del contenido',
      advanced: 'Tags, datos actualizados e instrucciones personalizadas',
    },
    badges: {
      required: 'Requerido',
      optional: 'Opcional',
      recommended: 'Recomendado',
      ready: 'Listo',
    },
  },
  contentSource: {
    prompt: 'Escribir contenido',
    promptDescription: 'Configura los datos directamente',
    video: 'Importar desde video',
    videoDescription: 'YouTube o TikTok',
    text: 'Pedile a la IA',
    textDescription: 'Chateá con la IA',
  },
  validation: {
    required: 'Este campo es requerido',
  },
  cta: {
    ready: 'Todo listo',
    readyHint: 'Tu artículo está configurado',
    completeBasics: 'Completa la información básica',
    completeBasicsHint: 'Título, keyword, entidad y aproximación',
    writeBrief: 'Escribe el brief',
    writeBriefHint: 'Genera o escribe el brief del contenido',
    selectBrandVoice: 'Selecciona una Voz de Marca primero',
  },
  briefSection: {
    disabledMessage: 'Completa los campos requeridos de arriba primero',
  },
  contentDataStep: {
    language: {
      label: 'Idioma del artículo',
      placeholder: 'Selecciona un idioma',
      options: {
        es: 'Español',
        en: 'Inglés',
        pt: 'Portugués',
      },
    },
    title: {
      label: 'Título del artículo',
      placeholder: 'Cómo proteger tu empresa del fraude en pagos digitales',
    },
    mainKeyword: {
      label: 'Palabra clave principal',
      placeholder: 'fraude en pagos digitales',
    },
    secondaryKeywords: {
      label: 'Palabras clave secundarias',
      placeholder: 'prevención de fraude, PCI DSS, tokenización',
      helper: 'Separadas por coma',
    },
    mainEntity: {
      label: 'Entidad principal',
      placeholder: 'Seguridad en pagos',
      helper: 'El tema o concepto principal sobre el que gira el contenido',
    },
    contentApproach: {
      label: 'Aproximación del contenido',
      placeholder: 'Artículo educativo dirigido a CTOs y responsables de seguridad de empresas B2B en Latinoamérica sobre prevención de fraude.',
      helper: 'Describe el enfoque y estructura del contenido (mínimo {{min}} caracteres)',
    },
    questionsToAnswer: {
      label: 'Dudas a responder',
      placeholder: '¿Cuáles son los fraudes más comunes?, ¿Cómo implementar autenticación multifactor?',
      helper: 'Preguntas que el contenido debería responder, separadas por coma',
    },
    referenceSources: {
      label: 'URLs de referencia',
      placeholder: 'https://www.pcisecuritystandards.org, https://www.visa.com/security',
      helper: 'URLs de fuentes a considerar, separadas por coma',
    },
    customPrompt: {
      label: 'Instrucciones personalizadas',
      placeholder: 'Ej: Quiero que todos los artículos arranquen con una métrica, Incluir 5 FAQs al final',
      helper: 'Instrucciones adicionales para personalizar la generación del contenido (opcional)',
    },
    images: {
      title: 'Imágenes',
      count: 'Cantidad de imágenes',
      countHelper: '(0-5 imágenes)',
      sourceLabel: 'Fuente de imágenes',
      sourceStock: 'Fotos de Stock',
      sourceAi: 'Generadas con IA',
      stockHelper: 'Las imágenes se buscarán en Magnific basándose en el título y secciones de tu contenido',
      aiFallbackLabel: 'Usar imágenes IA si el stock no está disponible',
      aiFallbackHelper:
        'Si el proveedor de stock falla, se usan imágenes generadas con IA. Desactívalo para dejar el contenido sin imágenes.',
      prompt: 'Estilo imágenes de sección (opcional)',
      promptPlaceholder: 'Ej: Estilo minimalista, colores corporativos',
      promptHelper: 'Aplica a las imágenes de sección. Si no especificas, se genera un estilo basado en el contenido',
      heroPrompt: 'Estilo imagen hero (opcional)',
      heroPromptPlaceholder: 'Ej: Cinematográfico, panorámico, colores vibrantes',
      heroPromptHelper: 'Instrucciones específicas para la imagen de portada. Si está vacío, usa el estilo de sección',
      styleLabel: 'Estilo visual',
      styleHelper: 'Elige el estilo visual de las imágenes generadas',
      styles: {
        illustrative: 'Ilustrativo',
        photographic: 'Fotográfico',
        infographic: 'Infográfico',
        abstract: 'Abstracto',
        'flat-design': 'Diseño Plano',
      },
      styleDescriptions: {
        illustrative: 'Ilustraciones digitales o a mano',
        photographic: 'Estilo fotográfico realista',
        infographic: 'Diagramas visuales con datos',
        abstract: 'Formas y composiciones abstractas',
        'flat-design': 'Vectores planos y minimalistas',
      },
    },
    referenceImages: {
      label: 'Imágenes de referencia',
      empty: 'Sin imágenes de referencia.',
      goToSettings: 'Subir en Identidad de Marca',
    },
    website: {
      label: 'Sitio Web para Interlinking',
      placeholder: 'Seleccionar sitio web',
      helper: 'Los links internos se buscarán en este sitio web',
      empty: 'Sin sitios web configurados.',
      goToSettings: 'Agregar',
    },
    factUpdate: {
      title: 'Actualizar datos',
      description: 'Busca en la web datos actualizados (precios, estadísticas, fechas) y los reemplaza en el contenido.',
      toggle: 'Activar actualización de datos',
      timeframe: {
        label: 'Buscar datos de',
        options: {
          last_24h: 'Últimas 24 horas',
          last_week: 'Última semana',
          last_month: 'Último mes',
          last_3_months: 'Últimos 3 meses',
          last_year: 'Último año',
        },
      },
    },
    folder: {
      title: 'Carpeta',
      description: 'Organiza este contenido en una carpeta.',
      assign: 'Asignar carpeta',
      change: 'Cambiar',
      searchFolders: 'Buscar carpetas...',
      noFoldersFound: 'Sin resultados',
      empty: 'Sin carpetas aún. Crea una abajo.',
      createNew: 'Crear nueva carpeta',
      namePlaceholder: 'Nombre de la carpeta',
      color: 'Color:',
      cancel: 'Cancelar',
      create: 'Crear',
      alreadyExists: 'Ya existe una carpeta con ese nombre',
    },
    tags: {
      title: 'Tags',
      description: 'Asigna tags para organizar y filtrar tu contenido.',
      empty: 'Sin tags disponibles. Crea uno con el botón de abajo.',
      selected: '{{count}} tags seleccionados',
      addTag: 'Agregar tag',
      searchTags: 'Buscar tags...',
      noTagsFound: 'Sin resultados',
      createNewTag: 'Crear nuevo tag',
      tagNamePlaceholder: 'Nombre del tag',
      tagColor: 'Color:',
      cancel: 'Cancelar',
      create: 'Crear',
      alreadyExists: 'Ya existe un tag con ese nombre',
    },
  },
  brandVoiceSelector: {
    label: 'Voz de Marca',
    placeholder: 'Selecciona una voz de marca',
    createNew: 'Crear Nueva',
    noBrandVoices: 'No se encontraron voces de marca. Crea tu primera voz de marca para continuar.',
    loading: 'Cargando voces de marca...',
    summary: {
      voiceTone: 'Tono de voz',
      audience: 'Audiencia',
      dos: '{{count}} sí',
      donts: '{{count}} no',
    },
  },
  briefPreviewStep: {
    generateDescription: 'Genera automáticamente un brief basado en los datos y voz de marca que configuraste',
    generateButton: 'Generar Brief',
    generating: 'Generando...',
    brief: {
      label: 'Brief del contenido',
      placeholder: 'El brief aparecerá aquí después de generarlo. También puedes escribirlo manualmente.',
      helperMin: 'Mínimo {{min}} caracteres para continuar',
      helperReady: 'Este brief guiará la generación del artículo',
    },
    info: {
      title: 'Información',
      item1: 'El brief resume la estructura y enfoque del artículo',
      item2: 'Puedes editar el brief generado para ajustarlo a tus necesidades',
      item3: 'Un brief más detallado produce mejores resultados',
    },
  },
  generationStep: {
    summary: {
      contentData: 'Datos del Contenido',
      brandVoice: 'Voz de Marca',
      brief: 'Brief',
      tags: 'Tags',
      title: 'Título:',
      mainKeyword: 'Keyword principal:',
      entity: 'Entidad:',
      secondaryKeywords: 'Keywords secundarias:',
      tone: 'Tono:',
      pointOfView: 'Punto de vista:',
      archetype: 'Arquetipo:',
      characters: '{{count}} caracteres',
    },
    images: {
      title: 'Imágenes',
      count: 'Cantidad de imágenes',
      countHelper: '(0-5 imágenes)',
      sourceLabel: 'Fuente de imágenes',
      sourceStock: 'Fotos de Stock',
      sourceAi: 'Generadas con IA',
      stockHelper: 'Las imágenes se buscarán en Magnific basándose en el título y secciones de tu contenido',
      prompt: 'Estilo imágenes de sección (opcional)',
      promptPlaceholder: 'Ej: Estilo minimalista, colores corporativos azul y blanco, ilustraciones profesionales',
      promptHelper: 'Aplica a las imágenes de sección. Si no especificas, se generará un estilo basado en el contenido del artículo',
      heroPrompt: 'Estilo imagen hero (opcional)',
      heroPromptPlaceholder: 'Ej: Cinematográfico, panorámico, colores vibrantes',
      heroPromptHelper: 'Instrucciones específicas para la imagen de portada. Si está vacío, usa el estilo de sección',
      style: 'Estilo visual',
    },
    generateButton: 'Generar Artículo',
    generating: 'Generando artículo...',
    loading: {
      title: 'Generando tu artículo...',
      goToContentsHint: 'Esto puede tardar unos minutos. No tienes que esperar aquí.',
      goToContents: 'Ir a Mis Contenidos',
      createNew: 'Crear nuevo contenido',
      steps: {
        analyzing: 'Analizando brief...',
        searching: 'Buscando en la web...',
        processing: 'Analizando fuentes...',
        writing: 'Escribiendo artículo...',
        updatingFacts: 'Actualizando datos...',
        verifying: 'Verificando calidad...',
      },
    },
    error: {
      title: 'Error en la generación',
    },
    result: {
      title: '¡Tu artículo está listo!',
    },
  },
  required: '*',
  verification: {
    summary: '{{passed}} de {{total}} criterios cumplidos',
    allPassed: 'Todos los criterios cumplidos',
    needsImprovement: {
      title: 'Necesitan mejora',
    },
    passed: {
      title: 'aprobados',
    },
    improve: 'Mejorar contenido',
    improving: 'Mejorando...',
    criteria: {
      short_paragraphs: 'Párrafos cortos',
      bold_usage: 'Uso de negritas',
      lists_tables: 'Listas y tablas',
      heading_hierarchy: 'Jerarquía de encabezados',
      appropriate_length: 'Longitud apropiada',
      faqs_included: 'FAQs incluidas',
      no_vague_intros: 'Aperturas concretas',
      data_density: 'Densidad de datos',
      entity_coverage: 'Cobertura de entidades',
      brand_voice: 'Voz de marca',
      keyword_presence: 'Keyword principal presente',
    },
  },
  metadata: {
    title: 'Metadatos SEO',
    tabs: {
      seo: 'SEO',
      social: 'Redes Sociales',
      schema: 'Schema.org',
    },
    fields: {
      titleTag: 'Título SEO',
      metaDescription: 'Meta Descripción',
      slug: 'URL Slug',
      geo: 'Geolocalización',
      schemaOrg: 'Datos Estructurados',
    },
  },
  videoImport: {
    title: 'Importar desde Video',
    description: 'Pega una URL de YouTube o TikTok para autocompletar el formulario con contenido extraído del video.',
    urlPlaceholder: 'https://www.youtube.com/watch?v=... o URL de TikTok',
    importButton: 'Importar',
    importing: 'Analizando video...',
    supported: 'Soportados: YouTube, TikTok',
    success: {
      title: 'Formulario autocompletado',
      description: 'Revisa y edita los campos antes de generar.',
    },
    progress: {
      'transcription-started': 'Transcribiendo video...',
      'platform-detected': 'Plataforma detectada',
      'transcription-complete': 'Transcripción completa',
      'extraction-started': 'Extrayendo datos del contenido...',
      'serp-enrichment-started': 'Analizando competencia...',
      'serp-enrichment-complete': 'Análisis de competencia completo',
    },
    errors: {
      invalidUrl: 'Ingresa una URL válida',
      unsupportedPlatform: 'Solo se soportan URLs de YouTube y TikTok',
      generic: 'Error al importar contenido del video',
    },
  },
  textImport: {
    title: 'Pedile a la IA',
    description: 'Contale qué artículo necesitás, como si le hablaras a un asistente. Podés dar instrucciones, pegar un texto, o mezclar ambos.',
    placeholder: 'Contale a la IA qué artículo querés...\n\nEjemplo: "Necesito un artículo sobre marketing digital para ecommerce en Latinoamérica. Que cubra SEO, redes sociales y email marketing. Tono profesional pero accesible."',
    extractButton: 'Extraer datos',
    extracting: 'Extrayendo datos...',
    extractingPhase1: 'Analizando competencia...',
    extractingPhase2: 'Generando datos...',
    success: {
      title: 'Formulario autocompletado',
      description: 'Revisa y edita los campos antes de generar.',
    },
    errors: {
      tooShort: 'El texto debe tener al menos 20 caracteres',
      tooLong: 'El texto no puede superar los 15,000 caracteres',
      generic: 'Error al extraer datos del texto',
    },
  },
  internalSources: {
    title: 'Fuentes Internas',
    description: 'Sube PDFs o agrega URLs de la documentación de tu empresa para asegurar una generación de contenido precisa.',
    dropzone: {
      label: 'Arrastra un PDF aquí o haz clic para subir',
      maxReached: 'Máximo {{max}} fuentes alcanzadas',
      fileSize: 'Archivos PDF hasta 10MB',
    },
    urlInput: {
      placeholder: 'https://docs-tu-empresa.com/articulo',
      addButton: 'Agregar URL',
    },
    sourcesList: {
      title: 'Fuentes Agregadas ({{count}}/{{max}})',
      readyToProcess: 'Lista para procesar',
    },
    toast: {
      fileTooLarge: {
        title: 'Archivo demasiado grande',
        description: 'Los archivos PDF deben ser menores a 10MB',
      },
      invalidFileType: {
        title: 'Tipo de archivo inválido',
        description: 'Solo se permiten archivos PDF',
      },
      maxSourcesReached: {
        title: 'Máximo de fuentes alcanzado',
        description: 'Solo puedes agregar hasta {{max}} fuentes',
      },
      pdfAdded: {
        title: 'PDF agregado',
        description: '{{fileName}} será procesado al generar el contenido',
      },
      urlRequired: {
        title: 'URL requerida',
        description: 'Por favor ingresa una URL',
      },
      invalidUrl: {
        title: 'URL inválida',
        description: 'Por favor ingresa una URL válida',
      },
      urlAdded: {
        title: 'URL agregada',
        description: 'El contenido será extraído al generar',
      },
      sourceRemoved: 'Fuente eliminada',
    },
  },
  serpAnalysis: {
    title: 'Resultados del Análisis SERP',
    debug: '(Debug)',
    searchQuery: {
      title: 'Consulta de Búsqueda',
    },
    searchIntent: {
      title: 'Intención de Búsqueda',
      types: {
        Informational: 'Informacional',
        Commercial: 'Comercial',
        Transactional: 'Transaccional',
        Navigational: 'Navegacional',
      },
    },
    summary: {
      title: 'Resumen',
    },
    commonH2Patterns: {
      title: 'Patrones H2 Comunes ({{count}})',
    },
    suggestedH2Structure: {
      title: 'Estructura H2 Sugerida ({{count}})',
      suggestedH3s: 'H3s Sugeridos:',
    },
    contentGaps: {
      title: 'Brechas de Contenido ({{count}})',
    },
    sourceUrls: {
      title: 'URLs Fuente ({{count}})',
    },
  },
} as const

export const contentOptimization = {
  tabs: {
    create: 'Crear',
    optimize: 'Optimizar',
  },
  input: {
    title: 'Optimizar contenido existente',
    description: 'Analiza una pagina publicada y recibe recomendaciones impulsadas por IA para mejorarla.',
    website: 'Sitio web',
    websitePlaceholder: 'Seleccionar sitio web',
    noWebsites: 'Sin sitios web configurados.',
    addWebsite: 'Agregar',
    url: 'URL de la pagina',
    urlPlaceholder: 'https://tu-sitio.com/blog/slug-del-articulo',
    urlHelper: 'Ingresa la URL completa de la pagina que quieres optimizar',
    analyzeButton: 'Analizar',
    brandVoice: 'Voz de marca',
    brandVoicePlaceholder: 'Seleccionar voz de marca',
    noBrandVoices: 'Sin voces de marca configuradas.',
    optional: 'Opcional',
    primaryKeyword: 'Keyword principal',
    primaryKeywordPlaceholder: 'ej: valor hora extra diurna 2026',
    primaryKeywordHelper:
      'Habilita las sugerencias de reescritura SEO para H1/H2/H3, body, title tag y meta description.',
    secondaryKeywords: 'Keywords secundarias',
    secondaryKeywordsPlaceholder: 'Separadas por coma, ej: hora extra diurna, recargo nocturno',
    secondaryKeywordsHelper: 'Se usan para mejorar cobertura de variantes en headings y body.',
    keepEmojis: 'Mantener los emojis existentes',
    keepEmojisHelper:
      'Preserva los emojis que ya están en headings y body. Dejalo apagado para removerlos como parte del rewrite.',
  },
  analyzing: {
    title: 'Analizando tu contenido...',
    extracting: 'Extrayendo contenido...',
    factUpdate: 'Analizando datos desactualizados...',
  },
  checklist: {
    title: 'Recomendaciones de optimizacion',
    back: 'Volver',
    selectedCount: '{{selected}} de {{total}} seleccionadas',
    selectAll: 'Seleccionar todas',
    deselectAll: 'Deseleccionar todas',
    original: 'Original',
    updated: 'Actualizado',
    customInstructions: 'Instrucciones personalizadas (opcional)',
    customInstructionsPlaceholder: 'Ej: Mantene el mismo tono, no cambies la introduccion...',
    customInstructionsHelper: 'Instrucciones adicionales para la IA al aplicar las recomendaciones',
    applyButton: 'Aplicar {{count}} recomendaciones',
    applying: 'Aplicando...',
    priority: {
      high: 'Alta',
      medium: 'Media',
      low: 'Baja',
    },
  },
  applying: {
    title: 'Aplicando optimizaciones...',
    description: 'La IA esta generando contenido optimizado con {{count}} recomendaciones aplicadas.',
    hint: 'Esto puede tardar unos minutos. Seras redirigido cuando este listo.',
  },
  categories: {
    fact_update: 'Datos Actualizados',
    keyword: 'Optimizacion de Keywords',
    interlink_outgoing: 'Links Internos Salientes',
    quality: 'Calidad del Contenido',
    headings_rewrite: 'Reescritura de Encabezados',
    body_cleaning: 'Limpieza del Body',
    title_tag: 'Title Tag',
    meta_description: 'Meta Description',
  },
  errors: {
    analyzeFailed: 'Error al analizar el contenido',
    applyFailed: 'Error al aplicar la optimizacion',
    invalidUrl: 'Ingresa una URL valida (ej: https://ejemplo.com)',
  },
  success: {
    applied: 'Optimizacion aplicada correctamente',
    optimized: 'Contenido optimizado correctamente!',
  },
  info: {
    title: 'Como funciona?',
    description: 'Pega una URL publicada, recibe recomendaciones potenciadas por IA, elegi cuales aplicar y guarda la version optimizada como contenido nuevo en Referent.',
    currentTitle: 'Que hace hoy',
    features: {
      interlinking: 'Sugiere links internos hacia otras paginas de tu sitio',
      qualityChecks: 'Detecta muletillas de IA, guiones, problemas de formato y puntuacion',
      customInstructions: 'Agrega instrucciones en texto libre para guiar la optimizacion',
      brandVoice: 'Aplica tu voz de marca al resultado optimizado',
      checklist: 'Checklist unificado para revisar y seleccionar recomendaciones',
      savedAsContent: 'Guarda el articulo optimizado como contenido nuevo en Referent',
    },
    v2Title: 'Proximamente',
    v2: {
      gscIntegration: 'Integracion con Google Search Console — gaps de keywords y oportunidades de ranking',
      inboundLinks: 'Sugerencias de links entrantes — paginas que deberian linkear a tu articulo',
      youtubeEmbeds: 'Embeds de YouTube — videos relevantes de tu canal',
      aiImages: 'Imagenes generadas por IA — visuales on-brand para secciones clave',
      boldKeywords: 'Negritas en keywords — resaltar keywords target con tags <strong>',
      factUpdate: 'Actualizacion de datos — detectar y reemplazar datos, estadisticas y fechas desactualizadas',
    },
    howItWorksTitle: 'Paso a paso',
    steps: {
      paste: 'Selecciona un sitio web y pega la URL de la pagina que queres optimizar',
      analyze: 'El sistema extrae el contenido y ejecuta analisis en paralelo',
      review: 'Revisa el checklist, desmarca lo que no quieras, agrega instrucciones custom',
      apply: 'Aplica y el articulo optimizado se guarda como contenido nuevo',
    },
  },
} as const
